import Badge from "@/components/base/Badge";
import { PAIEMENT_STATUT_LABELS, PAIEMENT_STATUT_TONES } from "@/store/billing/types";
import type { PaiementAbonnementStatut } from "../types";

const ICONS: Record<PaiementAbonnementStatut, string> = {
  en_attente: "ri-time-line",
  valide: "ri-checkbox-circle-line",
  rejete: "ri-close-circle-line",
  annule: "ri-forbid-line",
};

interface PaiementStatutBadgeProps {
  statut: PaiementAbonnementStatut;
}

/**
 * Badge de statut d'un paiement d'abonnement. Réutilise les libellés et teintes
 * partagés (`@/store/billing/types`) pour rester cohérent avec le Super Admin.
 */
export default function PaiementStatutBadge({ statut }: PaiementStatutBadgeProps) {
  return (
    <Badge tone={PAIEMENT_STATUT_TONES[statut]} icon={ICONS[statut]}>
      {PAIEMENT_STATUT_LABELS[statut]}
    </Badge>
  );
}